import * as ActionTypes from '../actions/StylingUserActionTypes';
import { IStylingUser, IWorkingHour } from '../Entities';
import { merge } from 'lodash';

export const StylingUserInitialState = {
    stylinguser: {
        list: [],
        modal: {
            stylingUser: {},
            availableLanguage: [],
            availableFirms: [],
            availableRoles: [],
            workingAreaMaps: []
        }
    }
};

export function getDefaultWorkingConfig(): IWorkingHour[] {
    return [0, 1, 2, 3, 4, 5, 6].map((day) => {
        return {
            id: -1,
            stylingUserId: -1,
            day: day,
            isAvailable: !(day === 0 || day === 6),
            start: '08:00:00',
            end: '17:00:00'
        };
    });
}

export default function stylingFirmsReducer(
    state: any = StylingUserInitialState.stylinguser,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_STYLING_USERS_SUCCESS:
            return {
                ...state,
                list: action.result
            };
        case ActionTypes.GET_STYLING_USER_SUCCESS: {
            let newstate = merge({}, state);

            newstate.modal.stylingUser = action.result;

            if (
                !newstate.modal.stylingUser.workingHours ||
                newstate.modal.stylingUser.workingHours.length < 1
            ) {
                newstate.modal.stylingUser.workingHours = getDefaultWorkingConfig();
            }

            return newstate;
        }
        case ActionTypes.STYLING_USER_LOAD_METADATA_SUCCESS: {
            let newstate = merge({}, state);
            newstate.modal.availableLanguage = action.result.languageKeys.map((lang) => {
                lang.id = lang.key;
                return lang;
            });
            newstate.modal.availableFirms = action.result.stylingFirms;
            newstate.modal.availableRoles = action.result.roles;

            if (newstate.modal.stylingUser) {
                newstate.modal.stylingUser = merge({}, state.modal.stylingUser);
            }

            return newstate;
        }
        case ActionTypes.SAVE_STYLING_USER_SUCCESS: {
            const newstate = merge({}, state);
            let user = action.result;
            let found = false;

            newstate.list = newstate.list.map((stylingUser: IStylingUser) => {
                if (stylingUser.id === user.id) {
                    found = true;
                    return merge({}, user);
                }
                return merge({}, stylingUser);
            });

            if (!found) {
                newstate.list.push(user);
            }

            return newstate;
        }
        case ActionTypes.REMOVED_STYLING_USER_SUCCESS: {
            let newstate = merge({}, state);
            newstate.list = newstate.list.filter((stylingUser: IStylingUser) => {
                return stylingUser.id !== action.result;
            });
            return newstate;
        }
        default:
            return merge({}, state);
    }
}
